// Product modules per workspace (addendum §1). Schemas in api-modules.ts.
import * as M from './api-modules.js';
import { route, W, Ws } from './route-def.js';

export const moduleRoutes = {
  listWorkspaceModules: route({
    method: 'GET', path: '/workspaces/:workspaceId/modules', summary: 'Módulos del espacio: activación, configuración y salud', tag: 'workspaces',
    minRole: 'viewer', params: Ws, response: M.WorkspaceModulesSchema,
  }),
  updateWorkspaceModule: route({
    method: 'PUT', path: '/workspaces/:workspaceId/modules/:module', summary: 'Activar o pausar un módulo (auditado)', tag: 'workspaces',
    minRole: 'admin', params: W({ module: M.ProductModuleSchema }), body: M.UpdateWorkspaceModuleSchema, response: M.WorkspaceModuleStateSchema,
  }),
  getModuleOnboarding: route({
    method: 'GET', path: '/workspaces/:workspaceId/modules/:module/onboarding', summary: 'Puesta en marcha del módulo: pasos con su estado real', tag: 'workspaces',
    minRole: 'manager', params: W({ module: M.ProductModuleSchema }), response: M.ModuleOnboardingSchema,
  }),
};

